import cookie from '../plugins/jquery.cookie.js';
import Headroom from '../plugins/headroom.js';

(function($) {

// Use this variable to set up the common and page specific functions. If you
// rename this variable, you will also need to rename the namespace below.
var Base = {
  // All pages
  common: {
    init: function() {
      /////
      // JavaScript to be fired on all pages
      /////

      // #! Redirect
      if (window.location.href.indexOf("/#!") > -1) {
        window.location.href = window.location.href.replace("/#!", "");;
      }

      // Donation Form
      $('.gfield.prices input').on('change', function(){
        $('.gfield.prices label').each(function(){
          var $this = $(this);
          if ($this.siblings('input:checked').length) {
            $this.addClass('checked');
            $('.gfield.number input, .gfield.gfield_total input').val($this.siblings('input:checked').val());
          } else {
            $this.removeClass('checked');
          }
        });
      });
      $('.gfield.number input').on('change', function(){
        var $this = $(this);
        $('.gfield.gfield_total input').val($this.val());
        $('.gfield.prices input').each(function() {
          var $this = $(this);
          $this.prop('checked', false);
        });
        $('.gfield.prices label').each(function() {
          var $this = $(this);
          $this.removeClass('checked');
        });
      });
      if ($('.gfield.gfield_total input').length) {
        setTimeout(function(){$('.gfield.gfield_total input').val($('.gfield.number input').val())},100);
      }
      //setInterval(function(){console.log($('.gfield.gfield_total input').val())}, 100);

      // Label Guide
      $('.labelguide-filter-toggle').click(function(){
        var $this = $(this);
        $this.toggleClass('active');
        var $cats = [];
        $('.labelguide-filter-toggle.active').each(function(){
          $cats.push($(this).data('cat'));
        });
        $('.labelguide-post').removeClass('disabled');
        $('.labelguide-post').each(function(){
          var $post = $(this);
          $.each( $cats, function( index, cat ){
            if (!$post.hasClass(cat)) {
              $post.addClass('disabled');
            }
          });
        });
        if (!$('.labelguide-post:not(.disabled)').length) {
          $('.no-labelguides').addClass('visible');
        } else {
          $('.no-labelguides').removeClass('visible');
        }
      });
      $('.labelguide-post').click(function(){
        var $this = $(this);
        $('#' + $this.data('id')).addClass('open');
      });
      $('.close-labelguide').click(function(){
        $('.labelguide-popup').removeClass('open');
      });

      // jQuery Random
      jQuery.fn.random = function() {
        var randomIndex = Math.floor(Math.random() * this.length);  
        return jQuery(this[randomIndex]);
      };

      // Sticky Header
      var myElement = document.querySelector(".global-header");
      var headroom  = new Headroom(myElement, {
        "offset": 150,
        "tolerance": 0
      });
      headroom.init();

      // Subnavigation
      if ($('.subnavigation').length) {
        var subnavmyElement = document.querySelector(".subnavigation .inner");
        var subnavheadroom  = new Headroom(subnavmyElement, {
          "offset": 150,
          "tolerance": 0
        });
        subnavheadroom.init();
        $(window).scroll(function(){
          if (($('.subnavigation').offset().top < $(window).scrollTop())) {
            $('.subnavigation .inner').addClass('stuck');
            $('.share-wrapper').addClass('shift');
          } else {
            $('.subnavigation .inner').removeClass('stuck');
            $('.share-wrapper').removeClass('shift');
          }
          $('.subnavigation .subnav-link').each(function(){
            if ($($(this).attr('href')).length) {
              if ($($(this).attr('href')).offset().top < $(window).scrollTop() + 50) {
                $('.subnavigation .subnav-link').removeClass('active');
                $(this).addClass('active');
                $('.subnavigation .dropdown-label .text').text($(this).text());
              }
            }
          });
        });
       $('body').on('click', function(e){
          if ($(e.target).hasClass('subnav-dropdown') || $(e.target).parents('.subnav-dropdown').length) {
            var $this = $('.subnav-dropdown');
            if (!$this.hasClass('open')) {
              e.preventDefault();
              $this.addClass('open');
            } else {
              $this.removeClass('open');
              $('.subnav-dropdown').scrollTop(0);
            }
          } else {
            $('.subnav-dropdown').removeClass('open');
            $('.subnav-dropdown').scrollTop(0);
          }
        });
     }

      // Filter
      $('body').on('click', function(e){
        if ($(e.target).hasClass('filter-dropdown') || $(e.target).parents('.filter-dropdown').length) {
          var $this = $('.filter-dropdown');
          if (!$this.hasClass('open')) {
            e.preventDefault();
            $this.addClass('open');
          } else {
            $this.removeClass('open');
          }
        } else {
          $('.filter-dropdown').removeClass('open');
        }
      });

      // Sticky Share
      if ($('.share-wrapper').length) {
        $(window).scroll(function(){
          if ($('.share-wrapper').offset().top < $(window).scrollTop() + 100) {
            $('.share-wrapper').addClass('stuck');
          } else {
            $('.share-wrapper').removeClass('stuck');
          }
        });
      }

      // Search
      $('.search-toggle').click(function(e){
        e.preventDefault();
        $('#search-popup').toggleClass('active');
        $('#search-input').focus();
        $(window).scrollTop(0);
      });
      $('.close-search').click(function(){
        $('#search-popup').removeClass('active');
      });

      // Cookied Popup
      var $delay = 0;
      if ($('.cookied-popup').length) {
        $delay = $('.cookied-popup').data('delay');
        setTimeout(function(){
          $('.cookied-popup').addClass('visible');
        }, $delay);
      }
      $('.close-cookie-popup').on('click', function(){
        $('.cookied-popup').fadeOut();
        $.cookie('popup', $('.cookied-popup').attr('id'), { path: '/' });
      });

      // Homepage Alert
      $('.close-homepage-alert').on('click', function(){
        $('.homepage-alert-wrapper').fadeOut();
        $.cookie('alert', $('.homepage-alert-wrapper').attr('id'), { path: '/' });
      });

      // Status Bar
      $('#status-close').on('click', function(){
        $('.status-bar').css('display', 'none');
        $.cookie('status', $('.status-bar').attr('id'), { path: '/' });
      });

      // Anchor
      $('a:not(.endnote)').on('click', function(e){
        var $href = $(this).attr('href'),
            $anchor = $href;
        if ($anchor.indexOf('#') > -1) {
          if (!$anchor.match('^#')) {
            $anchor = $anchor.substr($anchor.indexOf('#'));
          }
          if ($($anchor).length > 0) {
            e.preventDefault();
            $('html, body').stop().animate({
              scrollTop: $($anchor).offset().top
            });
          } else {
            window.location.href = $href;
          }
        }
      });

      // Endnote
      $('.endnotes-toggle').on('click', function(){
        $(this).parents('.endnotes-wrapper').toggleClass('open');
      })
      $(window).resize(function(){
        $('.endnote-popup').remove();
      });
      $('a.endnote').on('click', function(e){
        e.preventDefault();
        $('.endnote-popup').remove();
        if ($($(this).attr('href')).length) {
          $('body').append('<div class="endnote-popup" style="left: ' + $(this).offset().left  + 'px; top: ' + ($(this).offset().top + 40) + 'px;">' + $($(this).attr('href')).html() + '<svg class="close-icon" width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg"><line y1="-1" x2="20.6968" y2="-1" transform="matrix(0.724751 0.689011 -0.724751 0.689011 1 2)" stroke="#959494" stroke-width="2"/><line y1="-1" x2="20.6968" y2="-1" transform="matrix(0.724751 -0.689011 0.724751 0.689011 2.33008 16.2603)" stroke="#959494" stroke-width="2"/></svg></div>');
        }
      });
      $('body').on('click', '.endnote-popup .close-icon', function(){
        $(this).parent('.endnote-popup').remove();
      });

      // Video popups
      $('a').on('click', function(e){
        var $target = $(this).attr('href');
        if ($target.toLowerCase().indexOf("vimeo") >= 0) {
          e.preventDefault();
          var $n = $target.lastIndexOf('/');
          var $vid = $target.substring($n + 1);
          $('.popup-content').html('<iframe src="https://player.vimeo.com/video/' + $vid + '/?autoplay=1&api=1" width="500" height="281" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>');
          $('.video-popup-wrapper').addClass('active');
          $('body, html').addClass('body-noscroll');
        }
        if ($target.toLowerCase().indexOf("youtu") >= 0 && !$(this).hasClass('social-link')) {
          e.preventDefault();
          var $y = $target.lastIndexOf('=');
          var $yid = $target.substring($y + 1);
          $('.popup-content').html('<iframe src="https://www.youtube.com/embed/' + $yid + '/?autoplay=1" width="500" height="281" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>');
          $('.video-popup-wrapper').addClass('active');
          $('body, html').addClass('body-noscroll');
        }
      });
      $('.close-popup').on('click', function(){
        $('.video-popup-wrapper').removeClass('active');
        $('.popup-content').html('');
        $('body, html').removeClass('body-noscroll');
      });

      // Take Action Mobile
      if ($(window).width() < 992 && $('.take_action').length) {
        $('.take_action .background-image').css('height', $('.take_action .right-content-wrapper').outerHeight() - 55);
      }

      // Mobile Nav
      var $scrollposition = 0;
      $('#mobile-nav-toggle').on('click', function(){
        var $navheight = $('#mobile-navigation').height() + 170;
        if ($(this).hasClass('active')) {
          $(window).scrollTop($scrollposition);
        } else {
          $scrollposition = $(window).scrollTop();
          $(window).scrollTop(0);
        }
        $('body, html').toggleClass('nav-locked');
        $('#mobile-navigation-wrapper').toggleClass('active');
        $(this).toggleClass('active');
      });
      $('.mobile-navigation-wrapper .menu-item-has-children').each(function(){
        $(this).prepend('<div class="toggle"></div>');
      });
      $('.mobile-navigation-wrapper .menu-item-has-children').on('click', '.toggle', function(){
        $(this).parent(' .menu-item-has-children').toggleClass('open');
      });

      // Resize for Match-Height and Slick-Slider glitch fix
      this.scroll_actions;
      $(window).bind('load', function(){
        $(window).trigger('resize');
        setTimeout(function(){ $(window).trigger('resize'); }, 500);
        this.scroll_actions;
      });
      $(document).ready(this.scroll_actions);
      $(window).scroll(this.scroll_actions);
    },
    scroll_actions: function() {
      $('.loading').each(function(){
        $(this).addClass('loaded');
      });
      $('.animate').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          $this.addClass('visible');
        }
      });
      $('.animate-1').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 100);
        }
      });
      $('.animate-2').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 200);
        }
      });
      $('.animate-3').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 300);
        }
      });
      $('.animate-4').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 400);
        }
      });
      $('.animate-5').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 500);
        }
      });
      $('.animate-6').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 600);
        }
      });
      $('.animate-7').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 700);
        }
      });
      $('.animate-8').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 800);
        }
      });
      $('.animate-9').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 900);
        }
      });
      $('.animate-10').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 1000);
        }
      });
      $('.animate-11').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 1100);
        }
      });
      $('.animate-12').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 1200);
        }
      });
      $('.animate-13').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 1300);
        }
      });
      $('.animate-14').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 1400);
        }
      });
      $('.animate-15').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 1500);
        }
      });
      $('.animate-16').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 1600);
        }
      });
      $('.animate-17').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 1700);
        }
      });
      $('.animate-18').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 1800);
        }
      });
      $('.animate-19').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 1900);
        }
      });
      $('.animate-20').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 2000);
        }
      });
      $('.animate-21').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 2100);
        }
      });
    }
  },
  // Home page
  home: {
    init: function() {
      // JavaScript to be fired on the home page
      $('.home-hero .background-image').random().addClass('reveal');
    }
  }
};

// The routing fires all common scripts, followed by the page specific scripts.
// Add additional events for more control over timing e.g. a finalize event
var UTIL = {
  fire: function(func, funcname, args) {
    var namespace = Base;
    funcname = (funcname === undefined) ? 'init' : funcname;
    if (func !== '' && namespace[func] && typeof namespace[func][funcname] === 'function') {
      namespace[func][funcname](args);
    }
  },
  loadEvents: function() {
    UTIL.fire('common');

    $.each(document.body.className.replace(/-/g, '_').split(/\s+/),function(i,classnm) {
      UTIL.fire(classnm);
    });
  }
};

$(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.